import { useCallback, useEffect, useState } from 'react'
import { Card, Tag, Spin } from 'antd'
import * as api from '@/api/workbench'
import MenuPermission from '@/components/MenuPermission'
import TopRight from './components/TopRight'
import MyEntrust from './components/MyEntrust'
import MyOrder from './components/MyOrder'
import WorkList from './components/WorkList'
import TodayCount from './components/TodayCount'

const Index = () => {
  const [data, setData] = useState(null)
  const [count, setCount] = useState({})
  const [drzgqk, setDrzgqk] = useState({})
  const [pjclsc, setPjclsc] = useState({})
  const [xzcwdb, setXzcwdb] = useState({})
  const [xmdb, setXmdb] = useState({})
  const [loading, setLoading] = useState(false)

  const getData = useCallback(async() => {
    const res = await api.getTopTarget()
    if(res.success) {
      setData(res.data)
    }
  }, [])

  // 获取统计数据
  const getCount = useCallback(async () => {
    const res = await api.getCount()
    if(res.success) {
      setCount(res.data || {})
    }
  }, [])

  const getCountByDrzgqk = useCallback(async () => {
    const res = await api.getCountByDrzgqk()
    if(res.success) {
      setDrzgqk(res.data || {})
    }
  }, [])

  const getCountByPjclsc = useCallback(async () => {
    const res = await api.getCountByPjclsc()
    if(res.success) {
      setPjclsc(res.data || {})
    }
  }, [])

  const getCountByXzcwdb = useCallback(async () => {
    const res = await api.getCountByXzcwdb()
    if(res.success) {
      setXzcwdb(res.data || {})
    }
  }, [])

  const getCountByXmdb = useCallback(async () => {
    const res = await api.getCountByXmdb()
    if(res.success) {
      setXmdb(res.data || {})
    }
  }, [])

  useEffect(() => {
    // setLoading(true)
    Promise.all([getData(), getCountByDrzgqk(), getCountByPjclsc(), getCountByXzcwdb(), getCountByXmdb()]).finally(() => {
      // setLoading(false)
    })
  }, [getData, getCountByDrzgqk, getCountByPjclsc, getCountByXzcwdb, getCountByXmdb])

  return (
    <Spin spinning={loading} wrapperClassName='full-spin'>
      <div className='flex h-full flex-column'>
        <div className='flex'>
          <div className='mr-10' style={{width: '660px'}}>
            <TopRight count={count} xzcwdb={xzcwdb} xmdb={xmdb} />
          </div>
          {
            data && (
              <div className='flex-1'>
                <Card size="small">
                  <div className='flex'>
                    <div className='flex-1'>
                      <span className='font-22 font-700 mr-10 vertical-middle'>{data.hm}</span>
                      {
                        data.bm && <Tag color="#0076F6" className='vertical-middle'>{data.bm}</Tag>
                      }
                    </div>
                    <div className='text-right ml-10'>
                      <div className='mt-2'>
                        <span className='text-999'>系统职位：</span>
                        <span>{data.zw}</span>
                      </div>
                      <div className='mt-2'>
                        <span className='text-999'>汇联易工号：</span>
                        <span>{data.hlygh}</span>
                      </div>
                    </div>
                  </div>
                  <div className='flex'>
                    <div className='flex-1'>
                      <span className='link'>修改密码</span>
                    </div>
                    <div className='text-right ml-20'>
                      <span className='text-999'>汇联易供应商编码：</span>
                      <span>{data.hlygyscode}</span>
                    </div>
                  </div>
                </Card>
              </div>
            )
          }
          
        </div>
        <TodayCount className='mt-10' count={count} drzgqk={drzgqk} pjclsc={pjclsc} />
        <MyEntrust className='mt-10' count={count} />
        {/* <MyOrder className='mt-10' count={count} /> */}
        <MenuPermission name='CW'>

          <WorkList className='mt-10' count={count} />
        </MenuPermission>
      </div>
    </Spin>
  )
}

export default Index
